"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.lineageHeaderClass = exports.lineageNavFilterIndicatorHeight = exports.LineageNavHeader = exports.lineageNavCssClass = exports.LineageNavContainer = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var Colors = widgets_1.TabStyles.Colors;
var Spacing = widgets_1.TabStyles.Spacing;
var Sizing = widgets_1.TabStyles.Sizing;
var Typography = widgets_1.TabStyles.Typography;
exports.LineageNavContainer = (0, data_catalog_shared_1.divWithStyle)('LineageNavContainer', {
    flex: 'none',
    width: 300,
    display: 'flex',
    flexDirection: 'column',
    lineHeight: '1.3em',
});
exports.lineageNavCssClass = (0, data_catalog_shared_1.cssClass)('LineageNav', {
    borderLeft: "".concat(Sizing.BorderWidth, "px solid ").concat(Colors.L6),
    padding: "".concat(Spacing.DefaultSpace, "px ").concat(Spacing.MediumSpace, "px")
});
exports.LineageNavHeader = (0, data_catalog_shared_1.divWithStyle)('LineageNavHeader', {
    fontSize: Typography.Sizing.XLarge,
    padding: Spacing.DefaultSpace,
    paddingBottom: Spacing.ExtraLargeSpace
});
exports.lineageNavFilterIndicatorHeight = 20;
exports.lineageHeaderClass = (0, data_catalog_shared_1.cssClass)('lineageHeaderClass', {
    justifyContent: 'space-between',
    height: "".concat(exports.lineageNavFilterIndicatorHeight, "px"),
    lineHeight: "".concat(exports.lineageNavFilterIndicatorHeight, "px"),
});
//# sourceMappingURL=LineageNavStyles.js.map